import React, { createContext, useContext, useState, ReactNode } from "react";
import { Classroom } from "../types/ClassroomModel";

interface ClassroomContextProps {
  classroom: Classroom | null;
  setClassroom: (classroom: Classroom | null) => void;
}

const ClassroomContext = createContext<ClassroomContextProps | undefined>(
  undefined
);

export const ClassroomProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [classroom, setClassroom] = useState<Classroom | null>(null);

  return (
    <ClassroomContext.Provider value={{ classroom, setClassroom }}>
      {children}
    </ClassroomContext.Provider>
  );
};

export const useClassroom = () => {
  const context = useContext(ClassroomContext);
  if (!context) {
    throw new Error("useClassroom must be used within a ClassroomProvider");
  }
  return context;
};
